<template>
	<span>
		<label class="radio-inline" style="padding-right:20px;" v-if="inline">
			<input type="radio" :value="optionValue" :checked="isChecked" @change="updateModel" ref="radio">
			<div v-html="optionText"></div>
		</label>

		<div class="radio" v-else>
			<label>
				<input type="radio" :value="optionValue" :checked="isChecked" @change="updateModel" ref="radio">
				<span v-html="optionText"></span>
			</label>
		</div>
	</span>
</template>

<script>
	import Base from './base';

	export default {
		extends: Base,

		props: {
			optionValue: { default: '' },
			optionText: { default: '' },
			inline: { default: true }
		},

		computed: {
			isChecked() {
				return this.value === this.optionValue;
			}
		},

		methods: {
			updateModel() {
				this.$emit('input', this.optionValue);
			}
		}
	};
</script>


// WEBPACK FOOTER //
// radio.vue?23c8aefd